import { render, staticRenderFns } from "./MiniDecoration.vue?vue&type=template&id=09854832&scoped=true"
import script from "./MiniDecoration.vue?vue&type=script&lang=js"
export * from "./MiniDecoration.vue?vue&type=script&lang=js"
import style0 from "./MiniDecoration.vue?vue&type=style&index=0&id=09854832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09854832",
  null
  
)

export default component.exports